import React from 'react';
import AuditAction from '@/audit/components/AuditAction';
import { states } from '@/constants/lifecycle';
import DeleteActionMenu from '@/components/ribbon-actions/DeleteActionMenu';
import ArchiveActionMenu from '@/components/ribbon-actions/ArchiveActionMenu';
import ApproveRequestsAction from './ApproveRequestsAction';
import DenyRequestsAction from './DenyRequestsAction';
import { approvalStatus } from '../constants';
import TransferRequestsAction from '../containers/TransferRequestsAction';
import DuplicateRequestAction from '../containers/DuplicateRequestAction';
import DownloadRequestActionMenu from '../containers/DownloadRequestActionMenu';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const RequestSummaryActions = ({ category, code }) => {
  const state = Selectors.useRequestSummaryActions({ category, code });
  const showApprove = Events.useShowApproveRequest(category, { code });
  const showArchive = Events.useShowArchiveRequest(category, { code });
  const showDelete = Events.useShowDeleteRequest(category, { code });
  const pending = state.readStatus === states.PENDING;

  return (
    <>
      {state.allowApprove && (
        <>
          <ApproveRequestsAction
            showApprove={() => showApprove({ action: approvalStatus.APPROVE })}
            disabled={state.status !== approvalStatus.PENDING || state.waiting}
          />
          <DenyRequestsAction
            showApprove={() => showApprove({ action: approvalStatus.DENY })}
            disabled={state.status !== approvalStatus.PENDING || state.waiting}
          />
        </>
      )}
      {state.allowTransfer && (<TransferRequestsAction category={category} code={code} />)}
      {state.allowClone && (<DuplicateRequestAction code={code} category={category} />)}
      {state.allowDownload && (<DownloadRequestActionMenu request={state.request} disabled={pending} />)}
      {state.allowAudit && (<AuditAction baseUrl={state.url} />)}
      {state.allowArchive && (<ArchiveActionMenu disabled={pending} isArchival onClick={showArchive} />)}
      {state.allowDelete && (<DeleteActionMenu onClick={showDelete} disabled={pending} />)}
    </>
  );
};

export default RequestSummaryActions;
